import { IDropdownOption } from "components/common/HighButton";
import { IHierarchyProperty } from "components/hierarchypage/HierarchyProperties";
import { IAppSettings } from "contexts/appsettings/interface";
import { eApplicationPermission, eHierarchyLevel } from "functions/api/enums";
import { createHierarchyTagProperty } from "functions/createHierarchyTagProperty";

const defaultDownloadOptions: IDropdownOption[] = [
  { label: "Standard notes", selected: true, propertiesKey: "Notes" },
  { label: "Programmer notes", selected: true, propertiesKey: "ProgrammerNotes" },
  { label: "SAP reference", selected: true, propertiesKey: "SapReference" },
  { label: "Program name", selected: true, propertiesKey: "ProgramName" },
  { label: "Output name", selected: true, propertiesKey: "OutputName" },
];

export const CorporateProps: IHierarchyProperty[] = [
  {
    key: "domainList",
    value: "",
    type: "string",
    label: "Available domains",
    /**
     * Validate the `domainList` value using a comparator object.
     *
     * @param _ - Unused first parameter kept for signature compatibility.
     * @param c - Comparator object containing the value to validate.
     * @returns A promise resolving to the validation result object.
     */
    validCondition: async (_, c) => ({
      success: true,
      data: {
        valid: c.value.match(/^[A-Z,]+$/) !== null,
        validationText:
          c.value.match(/^[A-Z,]+$/) === null
            ? "Domains must be uppercase and separated by commas"
            : "",
      },
    }),
  },
];

const TAProps: IHierarchyProperty[] = [createHierarchyTagProperty(eHierarchyLevel.TA)];

const ProjectProps: IHierarchyProperty[] = [
  createHierarchyTagProperty(eHierarchyLevel.Project, "D"),
];

export const StudyProps: IHierarchyProperty[] = [
  createHierarchyTagProperty(eHierarchyLevel.Study),
  { key: "description", value: "", type: "textarea", label: "Description" },
  { key: "phase", value: "", type: "string", label: "Phase" },
  {
    key: "status",
    value: "Not started",
    type: "select",
    label: "Status",
    allowedValues: ["Not started", "In progress", "Completed"],
  },
  {
    key: "studyStandardsDate",
    value: new Date(Date()).toISOString().slice(0, 11) + "00:00:00.000Z",
    type: "datetime-local",
    label: "Standards date",
    futureBad: true,
    blankBad: true,
    permissionRequired: [eApplicationPermission.AllowStudyStandardDateEdit],
  },
];

const ReportProps: IHierarchyProperty[] = [
  { key: "description", value: "", type: "textarea", label: "Description" },
  { key: "reportType", value: "", type: "string", label: "Report type" },
];

export const defaultSettings: IAppSettings = {
  appSettingsLoaded: true,
  applicationPermissions: [],
  backEndUrl: "http://localhost:5218/",
  backEndVersion: "0.0.0",
  colWidthMod: 4.4,
  crystalUrl: "https://localhost:5000/",
  defaultColumnWidth: 30,
  defaultDownloadOptions,
  defaultLevelProperties: {
    Corporate: CorporateProps,
    TA: TAProps,
    Project: ProjectProps,
    Study: StudyProps,
    Report: ReportProps,
  },
  defaultTableStyle: { fontFamily: "Courier New", fontSize: "9pt", fontWeight: 500 },
  displayName: "DEFAULT NoAuth",
  domain: "astrazeneca.net",
  figureSettings: {
    figureTypeSettings: [],
    figureProperties: [],
    figureAxisSettings: [],
    figureLegendSettings: [],
    figureRegressionLineSettings: [],
    figureReferenceLinesSettings: [],
  },
  helpLinks: [],
  isAdmin: false,
  maintenanceMessage: "",
  maintenanceMode: false,
  prid: "no-prid",
  styles: [],
  annotationComparatorTypes: [],
  userId: 0,
};
